/**
 * QueryText component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const QueryText = styled.div<Props>`
  color: ${(props) => (props.focused ? Colors['light'] : Colors['grey'])};
  cursor: pointer;
  font-size: ${Screen.widthRatio * 30}px;
  font-family: ${Fonts['regular']};
  opacity: ${(props) => (props.focused ? 1 : 0.65)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
  text-overflow: ellipsis;
  margin-bottom: ${10 * Screen.widthRatio}px;
  width: ${273 * Screen.widthRatio}px;
`;

export default QueryText;
